export enum PlcCommunicationType {
  EthernetIp = 'EthernetIp',
  Profinet = 'Profinet',
  EtherCat = 'EtherCat',
  PowerLink = 'PowerLink',
}
